const Status = {

  Initial: "Initial",
  Loaded: "Loaded",
  Loading: "Loading",
  Error: "Error",
  ShowUserLogin: "ShowUserLogin"

};

export default Status;